/**
 * @Description: 舆情列表路由
 * @author zhaijiayu
 * @date 2021/8/17
*/

import Newspaper from '../../../pages/opinion/newspaper'

const list = [
    {
        path: '/newspaper',
        component: Newspaper,
        name: 'newspaper'
    }
]
export default list